var PageService = require('services/page-service');
var utils = require('lib/utils');
var CourseSettingsService = require('services/course-settings-service');
var LocalStorageService = require('services/local-storage-service');

var NavigationService = {
  initialize: function(){
    Chaplin.mediator.subscribe('page:navigate', this.navigatePage, this);
    Chaplin.mediator.subscribe('window:navigate', this.navigateWindow, this);
  },

  navigatePage: function(destination){
    //TODO: figure out another/better way of managing this information
    // pageNavigation posts what the current page is and what
    // the intended destination is to a globally accessible value
    var page;
    if (destination === 'skip'){
      destination = this.direction || 'forward';
    }
    this.direction = null;
    switch(destination){
      //TODO: not sure this logic is complete - need to discuss more scenarios
      case 'back':
        this.direction = 'back';
        page = PageService.getPreviousPage();
        break;
      case 'forward':
        this.direction = 'forward';
        page = PageService.getNextPage();
        break;
      case 'home':
        page = null;
        break;
      default:
        page  = PageService.getPageByKey(destination);
    }
    EF.module.currentActivity.originPage = EF.module.currentActivity.currentPage.get('key');
    EF.module.currentActivity.destinationPage = page ? page.get('key') : null;

    var currPage = EF.module.currentActivity.currentPage;
    if (currPage && (currPage.get('transition') || CourseSettingsService.get('transitionAll'))) {
      currPage.set('transition-out', destination === 'back' ? 'back' : 'forward');
      //console.log(`navigating away from ${currPage.get('key')}; setting transition-out to ${currPage.get('transition-out')}`);
    }

    if (page && (page.get('transition') || CourseSettingsService.get('transitionAll'))) {
      page.set('transition-in', destination === 'back' ? 'back' : 'forward');
      //console.log(`navigating to ${page.get('key')}; setting transition-in to ${page.get('transition-in')}`);
    }

    var navigate = function(){
      if (page){
        utils.redirectToPage(page);
      } else{
        if (EF.module && CourseSettingsService.get('menu').type == 'group') {
          var group = EF.groups.find(function(group) {
            return group.get('id') === EF.module.get('group');
          });
          utils.redirectTo('controllers/menu#show', { type: group.get('key') });
        } else {
          utils.redirectTo('controllers/menu#show');
        }
      }
    };

    //console.log('publishing action:unload in navigation-service');
    Chaplin.mediator.once('page:state:unloaded', navigate);
    Chaplin.mediator.publish('action:unload');
  },

  navigateWindow: function(destination){
    console.log("Navigating Window", destination);
    window.location.assign(destination);
  },

  reload: function(view) {
    Backbone.history.stop();  // will be restarted by controllers/reload-controller
    LocalStorageService.setItem('originFragment', Backbone.history.fragment);
    Chaplin.utils.redirectTo({ url: 'reload' });
  }
};

module.exports = NavigationService;
